import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { BillingSubscriptionCategory, dateParser, enumParser, memberRoleParser, memberStatusParser, recurringIntervals, ssoJoinStatusParser, workspaceMfaRequirementParser, workspaceStatusParser, workspaceSuspensionReasonParser, } from '#validation';
export const LimitsStatus = ['ok', 'approachLimits', 'reachLimits'];
export const WorkspaceBillingSchema = z.object({
    awsMarketplaceContractId: z.number().nullish(),
    subscription: z
        .object({
        id: z.number().optional(),
        name: z.string().optional(),
        category: enumParser(BillingSubscriptionCategory).optional(),
        type: z.enum(recurringIntervals).optional(),
        description: z.string().nullish(),
        status: z.string().optional(),
        periodStart: dateParser().optional(),
        periodEnd: dateParser().optional(),
        currentUsedSlots: z.number().optional(),
        periodStartUsedSlots: z.number().optional(),
    })
        .optional(),
    partnerOrganizationId: z.string().nullish(),
    billingUnitId: z.string().nullish(),
});
export const WorkspaceResponseSchema = z.object({
    id: z.string(),
    name: z.string(),
    adminPublicKey: z.string(),
    mfaRequirement: workspaceMfaRequirementParser.default('optional'),
    canDelete: z.boolean().optional(),
    canRename: z.boolean().optional(),
    canDeclineInvite: z.boolean().optional(),
    hasActiveFilespaceMigrations: z.boolean().optional(),
    canCreateFilespace: z.boolean().optional(),
    hasDataBeenUploadedToAnyFilespace: z.boolean().optional(), // inidicates if data has been ever added to any filespace in the workspace
    status: workspaceStatusParser,
    suspensionReason: workspaceSuspensionReasonParser.nullish(),
    isOnboardingCompleted: z.boolean().optional(),
    createdAt: dateParser(),
    updatedAt: dateParser(),
    deletedAt: dateParser().nullish(),
    memberStatus: memberStatusParser.optional(), // Member status for the current user in this workspace
    memberRole: memberRoleParser.optional(), // Role of the current user in this workspace
    ssoJoinStatus: ssoJoinStatusParser.optional(),
    billing: WorkspaceBillingSchema.optional(),
    capabilitiesLimitsStatus: z
        .object({
        members: z.enum(LimitsStatus),
        storage: z.enum(LimitsStatus),
        trial: z.enum(LimitsStatus).optional(),
    })
        .optional(),
});
export class WorkspaceResponseDto extends createZodDto(WorkspaceResponseSchema) {
}
